// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editor-sidenav {
    position: fixed;
    margin-top: 36px;
    height: calc(100% - 74px);
    padding: 7px;
    width: 350px;
}

.sidepanel-selector {
    position: fixed;
    margin-top: 36px;
    height: calc(100% - 74px);
    padding: 7px;
    width: 370px;
}

@media (min-width: 1601px) {
    .editor-sidenav {
        width: 450px;
    }
}

#svg_editor_container {
    background: #aaa;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 0px;
    left: 0px;
}

.svg-workarea-toolbar {
    min-height: 46px;
    height: 46px;
}
.svg-workarea-leftbar-p {
    box-shadow: none !important;
    background-color: var(--toolboxBackground);
    color: var(--toolboxColor);
}

.svg-workarea-leftbar-h {
    max-height: 23px;
    text-align: center;
    vertical-align: middle;
    padding-left: 0px;
    padding-right: 0px;
    border-top: 1px solid var(--toolboxBorder);
    margin-bottom: 0px;
    box-shadow: 0px 1px 3px 0px #000;
}

.svg-workarea-leftbar-h span {
    padding-top: 5px !important;
    padding-left: 3px;
    font-size: 11px;
}

/* .mat-expansion-panel-content {
  background-color: rgb(53, 3, 3);
} */

.svg-workarea-flybar-h {
    max-height: 23px;
    text-align: center;
    vertical-align: middle;
    padding-left: 0px;
    padding-right: 0px;
    border-top: 1px solid var(--toolboxBorder);
    box-shadow: 0px 1px 3px 0px #000;
 }

 .svg-workarea-flybar-h span {
     padding-top: 5px !important;
     padding-left: 3px;
     font-size: 11px;
 }

 /* .svg-workarea-flybar-h:hover {
 } */

 .svg-workarea-flybar-h:enabled .svg-workarea-flybar-h::selection{
     color: rgba(255,255,255,1);
 }

.svg-workarea-fly-p {
    box-shadow: none !important;
    background-color: var(--toolboxBackground);
    color: var(--toolboxColor);
    width: 200px;
    padding-left: 0px;
    padding-right: 0px;
}

.svg-property-split3:after {
    display: table;
    clear: both;
}

.svg-property-split3 div {
    /* float: left; */
    /* width: 49%; */
    display: inline-block;
}

.svg-property-split2:after {
    display: table;
    clear: both;
}

.svg-property-split2 div {
    /* float: left; */
    /* width: 49%; */
    display: inline-block;
}

.svg-property {
    color: var(--toolboxFlyColor);
}

.svg-property span {
    /* float: left; */
    display: block;
    font-size: 10px;
    margin: 0px 5px 0px 10px;
}

.svg-property input {
    /* float: right; */
    /* position: relative; */
    /* left: 0px; */
    /* right: 0px; */
    display: block;
    margin: 0px 10px 12px 10px;
    border: unset;
    background-color: inherit;
    color: inherit;
    border-bottom: 1px solid var(--toolboxFlyColor);
}

.svg-workarea-container {
    display: block;
    height: 100%;
}

.svg-preview {
    background-color: #3058af36;
    height: 0px;
    width: 0px;
    z-index: 1;
    position: absolute;
}

#rulers > div {
    background-color: var(--svgEditRulersBackground) !important;
    color: var(--svgEditRulersColor) !important;
}

#svgcanvas {
    background-color: var(--svgEditWorkareaBackground) !important;
}

.contextMenu {
    background-color: var(--svgEditWorkareaContextMenu) !important;
}

.contextMenu A {
    color: var(--svgEditWorkareaContextColor) !important;
}

.contextMenu LI:not(.disabled) A:hover {
    color: var(--toolboxItemActiveColor) !important;
}

.contextMenu LI.separator {
    margin-top: 0px !important;
    border-color: var(--svgEditWorkareaContextBorder) !important;
}

.svg-tools-fly {
    z-index: 9999;
    position: absolute;
    right: 15px;
    top: 55px;
    /* overflow-y: auto; */
    max-height: calc(100% - 75px);
    background-color: var(--toolboxBackground);
    box-shadow: 0px 1px 4px 0px #000;
}

.svg-tool-button {
    vertical-align: middle;
    display: inline-table;
    /* display: inline-block; */
    cursor: pointer;
    height: 30px;
    width: 30px;
    border-radius: 50%;
    margin: 2px 2px 2px 2px;
    background-color: var(--toolboxButton);
    /* padding-top: 5px; */
}

.svg-tool-button span {
    display: block;
    margin: auto;
}

.svg-tool-button:hover {
    background: rgba(0, 0, 0, 0.1);
}

.svg-tool-active, .svg-tool-active:active, .svg-tool-active:hover {
    background-color: rgba(48,89,175,1);
}

.leave-header-area {
    margin-top: 36px;
}

.svg-sidenav {
    min-width: 160px;
    max-width: 300px;
    width: 300px;
    background: var(--sidenavBackground);
}

/* tool bar top */
.tools_panel {
    background-color: var(--headerBackground);
    color: var(--headerColor);
}
.main-btn {
    height: 34px;
    width: 34px;
    min-width: unset !important;
    padding: unset !important;
    line-height: 34px;
    margin-left: 5px;
    margin-right: 5px;
}

.main-btn mat-icon {
    font-size: 24px;
    height: unset;
    width: unset;
}

.main-btn .to-top {
    display: inline-block;    ;
    height: 34px;
    width: 34px;    
}

.main-btn .to-bottom  {
    display: inline-block;
    height: 34px;
    width: 34px;
}

.main-btn .to-path {
    display: inline-block;
    height: 34px;
    width: 34px;
}

.main-btn .group {
    background: url("/assets/images/group.svg") no-repeat center center;
    background-size: contain;
    display: inline-block;
    height: 34px;
    width: 34px;
}

.main-btn .ungroup {
    background: url("/assets/images/ungroup.svg") no-repeat center center;
    background-size: contain;
    display: inline-block;
    height: 34px;
    width: 34px;
}

.main-btn-sep {
    width: 1px;
    background: #888;
    border-left: 1px outset #888;
    margin: 5px 3px;
    padding: 0;
    height: 24px;
}

.svg-element-selected {
    display: inline-flex;
}

/* --------------- */
/* left panel */
/* --------------- */
.view-panel {
    overflow: auto;
    cursor: s-resize;
}
.leftbar-edit-btn {
    margin-top: 2px;
    font-size: 18px;
    height: 18px;
    width: 18px;
    padding-right: 15px;
}

.leftbar-panel {
    margin-top: 4px;
    padding: 0px 0px 0px 0px;
    font-size: 11px;
    background-color: var(--toolboxPanelBackground);
    color: var(--toolboxColor);
    overflow: auto;
}

.leftbar-panel.h200 {
    max-height: 200px;
}

.leftbar-item {
    padding: 3px 0px 1px 0px;
    display: flow-root;
}

.leftbar-item-active {
    background-color: var(--toolboxItemActiveBackground);
    color: var(--toolboxItemActiveColor);
}

.leftbar-item span {
    float: left;
}

.leftbar-item .leftbar-item-type {
    float: left;
    padding-left: 4px;
    font-size: 16px;
    line-height: 20px;
    opacity:0.5;
}

.leftbar-item mat-icon {
    float: right;
    font-size: 18px;
}

::ng-deep .svg-workarea-leftbar-p .mat-expansion-panel-body {
    margin: 0px 0px 0px 0px !important;
    padding: 0px 0px 0px 0px !important;
    /* padding-left: 10px !important; */
    flex-wrap: wrap !important;
}

::ng-deep .svg-workarea-fly-p .mat-expansion-panel-body {
    margin: 0px 0px 0px 0px !important;
    padding: 0px 0px 0px 0px !important;
    /* padding-left: 10px !important; */
    flex-wrap: wrap !important;
}

::ng-deep .mat-menu-item {
    font-size: 11px;
    height: 30px !important;
    line-height: unset !important;
}

.rightbar-panel {
    margin-top: 4px;
    background-color: var(--toolboxPanelBackground);
    color: var(--toolboxColor);
}

.rightbar-input {
    width: 70px;
}

.mat-expansion-panel-header-title span {
    padding-top: 3px;
}
.mat-expansion-panel-spacing {
    margin: 0px 0px 0px 0px !important;
}

.bottom-bar {
    position: absolute;
    left: 0px;
    right: 0;
    bottom: 0;
    height: 30px;
    overflow: visible;
}

.zoom-menu {
    float: left;
    padding-left: 5px;
    width: 90px;
}

.zoom-value {
    border: unset;
    display: inline-block;
}

.zoom-label {
    display: inline-block;
    height: 25px;
}
.zoom-value span {
    display: inline-block;
}

.zoom-value .selection,
button {
    display: inline-block;
}
.zoom-value button {
    /* width: unset; */
    z-index: 9999;
    background-color: var(--footZoomBackground);
    color: var(--footZoomColor);
    border: unset;
}

.zoom-value ul,
li {
    /* width: unset; */
    background-color: var(--footZoomBackground);
    color: var(--footZoomColor);
    border: unset;
}

.zoom-value ul {
    left: 0px;
}

.zoom-value li:hover {
    background-color: var(--footZoomBackgroundHover);
}

.colors {
    position: absolute;
    left: 25px;
    top: 0px;
}

.colors-palette {
    position: absolute;
    left: 165px;
    top: 0px;
    right: 0px;
    bottom: 0px;
}

.color-fill {
    position: relative;
    top: 4px;
    left: 12px;
    cursor: pointer;
    width: 13px;
    height: 13px;
    border: 1px solid rgba(71, 71, 71, 1);
}

.color-stroke {
    position: absolute;
    top: 4px;
    left: 30px;
    cursor: pointer;
    width: 13px;
    height: 13px;
    border: 1px solid rgba(71, 71, 71, 1);
}

.style-stroke {
    display: block !important;
    margin: 0px 10px 12px 10px;
    background-color: inherit;
    color: inherit;
    background-color: var(--toolboxPanelBackground);
    color: var(--toolboxColor);
}

.style-stroke option {
    background-color: var(--toolboxPanelBackground);
    color: var(--toolboxColor);
}

.font-family {
    display: block;
    margin: 0px 10px 12px 10px;
    background-color: inherit;
    color: inherit;
    width: 174px;
}

.font-family option {
    background-color: var(--toolboxPanelBackground);
    color: var(--toolboxColor);
}

.text-align {
    display: block;
    margin: 0px 10px 12px 10px;
    background-color: inherit;
    color: inherit;
    width: 75px;
}

.text-align option {
    background-color: var(--toolboxPanelBackground);
    color: var(--toolboxColor);
}

.view-item-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: calc(100% - 54px);
}

select#start_marker option[value="A"] {
    background: url("/assets/images/select-pointer.svg");
}
select#start_marker option[value="B"] {
    background: url("/assets/images/select-pointer.svg");
}
select#start_marker option[value="C"] {
    background: url("/assets/images/select-pointer.svg");
}
select#start_marker option[value="D"] {
    background: url("/assets/images/select-pointer.svg");
}

.icon-select {
    background: url("/assets/images/select-pointer.svg") no-repeat center center;
    background-size: contain;
    height: 30px;
    width: 30px;
}

.icon-pencil {
    background: url("/assets/images/pencil.svg") no-repeat center center;
    background-size: contain;
    height: 30px;
    width: 30px;
}

.icon-line {
    background: url("/assets/images/line.svg") no-repeat center center;
    background-size: contain;
    height: 30px;
    width: 30px;
}

.icon-rect {
    background: url("/assets/images/rect.svg") no-repeat center center;
    background-size: contain;
    height: 30px;
    width: 30px;
}

.icon-circle {
    background: url("/assets/images/circle.svg") no-repeat center center;
    background-size: contain;
    height: 30px;
    width: 30px;
}

.icon-ellipse {
    background: url("/assets/images/ellipse.svg") no-repeat center center;
    background-size: contain;
    height: 30px;
    width: 30px;
}

.icon-path {
    background: url("/assets/images/path.svg") no-repeat center center;
    background-size: contain;
    height: 30px;
    width: 30px;
}

.icon-text {
    background: url("/assets/images/text.svg") no-repeat center center;
    background-size: contain;
    height: 30px;
    width: 30px;
}

.icon-image {
    background: url("/assets/images/image.svg") no-repeat center center;
    background-size: contain;
    height: 30px;
    width: 30px;
}

.icon-align-left {
    background: url("/assets/images/align-left.svg") no-repeat center center;
    background-size: contain;
    height: 30px;
    width: 30px;
}

.icon-align-center {
    background: url("/assets/images/align-center.svg") no-repeat center center;
    background-size: contain;
    height: 30px;
    width: 30px;
}

.icon-align-right {
    background: url("/assets/images/align-right.svg") no-repeat center center;
    background-size: contain;
    height: 30px;
    width: 30px;
}

.icon-align-top {
    background: url("/assets/images/align-top.svg") no-repeat center center;
    background-size: contain;
    height: 30px;
    width: 30px;
}

.icon-align-middle {
    background: url("/assets/images/align-middle.svg") no-repeat center center;
    background-size: contain;
    height: 30px;
    width: 30px;
}

.icon-align-bottom {
    background: url("/assets/images/align-bottom.svg") no-repeat center center;
    background-size: contain;
    height: 30px;
    width: 30px;
}

.icon-flip-orizontal {
    background: url("/assets/images/flip-orizontal.svg") no-repeat center center;
    background-size: contain;
    height: 30px;
    width: 30px;
}

.icon-flip-vertical {
    background: url("/assets/images/flip-vertical.svg") no-repeat center center;
    background-size: contain;
    height: 30px;
    width: 30px;
}

.icon-linejoin-miter {
    background: url("/assets/images/linejoin-miter.svg") no-repeat center center;
    background-size: contain;
    height: 30px;
    width: 30px;
}

.icon-linejoin-round {
    background: url("/assets/images/linejoin-round.svg") no-repeat center center;
    background-size: contain;
    height: 30px;
    width: 30px;
}

.icon-linejoin-bevel {
    background: url("/assets/images/linejoin-bevel.svg") no-repeat center center;
    background-size: contain;
    height: 30px;
    width: 30px;
}

.icon-linecap-butt {
    background: url("/assets/images/linecap-butt.svg") no-repeat center center;
    background-size: contain;
    height: 30px;
    width: 30px;
}

.icon-linecap-square {
    background: url("/assets/images/linecap-square.svg") no-repeat center center;
    background-size: contain;
    height: 30px;
    width: 30px;
}

.icon-linecap-round {
    background: url("/assets/images/linecap-round.svg") no-repeat center center;
    background-size: contain;
    height: 30px;
    width: 30px;
}

.icon-tool {
    background-size: auto;
    height: 30px;
    width: 30px;
    color: rgba(255, 255, 255, 1);
    background-position: center; /* Center the image */
    background-repeat: no-repeat; /* Do not repeat the image */
}

.material-icon-tool {
    text-align: center;
    line-height: 30px;
    font-size: 22px;
}

.icon-switch {
    background: url("/assets/images/switch.svg") no-repeat center center;
}
.icon-value {
    background: url("/assets/images/value.svg") no-repeat center center;
}
.icon-editvalue {
    background: url("/assets/images/editvalue.svg") no-repeat center center;
}
.icon-selectvalue {
    background: url("/assets/images/selectvalue.svg") no-repeat center center;
}
.icon-progress-v {
    background: url("/assets/images/progress-v.svg") no-repeat center center;
}
.icon-semaphore {
    background: url("/assets/images/semaphore.svg") no-repeat center center;
}
.icon-button {
    background: url("/assets/images/button.svg") no-repeat center center;
}
.icon-chart {
    background: url("/assets/images/chart.svg") no-repeat center center;
}
.icon-bag {
    background: url("/assets/images/bag.svg") no-repeat center center;
}
.icon-pipe {
    background: url("/assets/images/pipe.svg") no-repeat center center;
}
.icon-slider {
    background: url("/assets/images/slider.svg") no-repeat center center;
}
.icon-graphbar {
    background: url("/assets/images/graphbar.svg") no-repeat center center;
}
.icon-table {
    background: url("/assets/images/table.svg") no-repeat center center;
}
.icon-iframe {
    background: url("/assets/images/iframe.svg") no-repeat center center;
}`, "",{"version":3,"sources":["webpack://./src/app/editor/editor.component.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,2BAA2B;IAC3B,0CAA0C;IAC1C,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,0CAA0C;IAC1C,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,2BAA2B;IAC3B,iBAAiB;IACjB,eAAe;AACnB;;AAEA;;GAEG;;AAEH;IACI,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,0CAA0C;IAC1C,gCAAgC;CACnC;;CAEA;KACI,2BAA2B;KAC3B,iBAAiB;KACjB,eAAe;CACnB;;CAEA;IACG;;CAEH;KACI,0BAA0B;CAC9B;;AAED;IACI,2BAA2B;IAC3B,0CAA0C;IAC1C,0BAA0B;IAC1B,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,0BAA0B;IAC1B,aAAa;IACb,yBAAyB;IACzB,cAAc;IACd,+CAA+C;AACnD;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,2BAA2B;IAC3B,WAAW;IACX,UAAU;IACV,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,2DAA2D;IAC3D,2CAA2C;AAC/C;;AAEA;IACI,6DAA6D;AACjE;;AAEA;IACI,8DAA8D;AAClE;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,0BAA0B;IAC1B,4DAA4D;AAChE;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,sBAAsB;IACtB,6BAA6B;IAC7B,0CAA0C;IAC1C,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;IACtB,qBAAqB;IACrB,2BAA2B;IAC3B,eAAe;IACf,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,uBAAuB;IACvB,sCAAsC;IACtC,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,oCAAoC;AACxC;;AAEA,iBAAiB;AACjB;IACI,yCAAyC;IACzC,yBAAyB;AAC7B;AACA;IACI,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,mEAAmE;IACnE,wBAAwB;IACxB,qBAAqB;IACrB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,qEAAqE;IACrE,wBAAwB;IACxB,qBAAqB;IACrB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,4BAA4B;IAC5B,eAAe;IACf,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,oBAAoB;AACxB;;AAEA,oBAAoB;AACpB,eAAe;AACf,oBAAoB;AACpB;IACI,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,eAAe;IACf,YAAY;IACZ,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,eAAe;IACf,+CAA+C;IAC/C,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI,oDAAoD;IACpD,oCAAoC;AACxC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,kCAAkC;IAClC,mCAAmC;IACnC,mCAAmC;IACnC,0BAA0B;AAC9B;;AAEA;IACI,kCAAkC;IAClC,mCAAmC;IACnC,mCAAmC;IACnC,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,+CAA+C;IAC/C,0BAA0B;AAC9B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,YAAY;AAChB;AACA;IACI,qBAAqB;AACzB;;AAEA;;IAEI,qBAAqB;AACzB;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,2CAA2C;IAC3C,2BAA2B;IAC3B,aAAa;AACjB;;AAEA;;IAEI,kBAAkB;IAClB,2CAA2C;IAC3C,2BAA2B;IAC3B,aAAa;AACjB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,UAAU;IACV,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,eAAe;IACf,WAAW;IACX,YAAY;IACZ,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,eAAe;IACf,WAAW;IACX,YAAY;IACZ,qCAAqC;AACzC;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,yBAAyB;IACzB,cAAc;IACd,+CAA+C;IAC/C,0BAA0B;AAC9B;;AAEA;IACI,+CAA+C;IAC/C,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,0BAA0B;IAC1B,yBAAyB;IACzB,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,+CAA+C;IAC/C,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,0BAA0B;IAC1B,yBAAyB;IACzB,cAAc;IACd,WAAW;AACf;;AAEA;IACI,+CAA+C;IAC/C,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,4BAA4B;AAChC;;AAEA;IACI,oDAAoD;AACxD;AACA;IACI,oDAAoD;AACxD;AACA;IACI,oDAAoD;AACxD;AACA;IACI,oDAAoD;AACxD;;AAEA;IACI,4EAA4E;IAC5E,wBAAwB;IACxB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,oEAAoE;IACpE,wBAAwB;IACxB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,kEAAkE;IAClE,wBAAwB;IACxB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,kEAAkE;IAClE,wBAAwB;IACxB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,oEAAoE;IACpE,wBAAwB;IACxB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,qEAAqE;IACrE,wBAAwB;IACxB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,kEAAkE;IAClE,wBAAwB;IACxB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,kEAAkE;IAClE,wBAAwB;IACxB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,mEAAmE;IACnE,wBAAwB;IACxB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,wEAAwE;IACxE,wBAAwB;IACxB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,0EAA0E;IAC1E,wBAAwB;IACxB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,yEAAyE;IACzE,wBAAwB;IACxB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,uEAAuE;IACvE,wBAAwB;IACxB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,0EAA0E;IAC1E,wBAAwB;IACxB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,0EAA0E;IAC1E,wBAAwB;IACxB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,4EAA4E;IAC5E,wBAAwB;IACxB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,2EAA2E;IAC3E,wBAAwB;IACxB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,4EAA4E;IAC5E,wBAAwB;IACxB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,4EAA4E;IAC5E,wBAAwB;IACxB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,4EAA4E;IAC5E,wBAAwB;IACxB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,0EAA0E;IAC1E,wBAAwB;IACxB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,4EAA4E;IAC5E,wBAAwB;IACxB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,2EAA2E;IAC3E,wBAAwB;IACxB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,WAAW;IACX,6BAA6B;IAC7B,2BAA2B,EAAE,qBAAqB;IAClD,4BAA4B,EAAE,4BAA4B;AAC9D;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,oEAAoE;AACxE;AACA;IACI,mEAAmE;AACvE;AACA;IACI,uEAAuE;AAC3E;AACA;IACI,yEAAyE;AAC7E;AACA;IACI,wEAAwE;AAC5E;AACA;IACI,uEAAuE;AAC3E;AACA;IACI,oEAAoE;AACxE;AACA;IACI,mEAAmE;AACvE;AACA;IACI,iEAAiE;AACrE;AACA;IACI,kEAAkE;AACtE;AACA;IACI,oEAAoE;AACxE;AACA;IACI,sEAAsE;AAC1E;AACA;IACI,mEAAmE;AACvE;AACA;IACI,oEAAoE;AACxE","sourcesContent":[".editor-sidenav {\n    position: fixed;\n    margin-top: 36px;\n    height: calc(100% - 74px);\n    padding: 7px;\n    width: 350px;\n}\n\n.sidepanel-selector {\n    position: fixed;\n    margin-top: 36px;\n    height: calc(100% - 74px);\n    padding: 7px;\n    width: 370px;\n}\n\n@media (min-width: 1601px) {\n    .editor-sidenav {\n        width: 450px;\n    }\n}\n\n#svg_editor_container {\n    background: #aaa;\n    height: 100%;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    position: absolute;\n    top: 0px;\n    left: 0px;\n}\n\n.svg-workarea-toolbar {\n    min-height: 46px;\n    height: 46px;\n}\n.svg-workarea-leftbar-p {\n    box-shadow: none !important;\n    background-color: var(--toolboxBackground);\n    color: var(--toolboxColor);\n}\n\n.svg-workarea-leftbar-h {\n    max-height: 23px;\n    text-align: center;\n    vertical-align: middle;\n    padding-left: 0px;\n    padding-right: 0px;\n    border-top: 1px solid var(--toolboxBorder);\n    margin-bottom: 0px;\n    box-shadow: 0px 1px 3px 0px #000;\n}\n\n.svg-workarea-leftbar-h span {\n    padding-top: 5px !important;\n    padding-left: 3px;\n    font-size: 11px;\n}\n\n/* .mat-expansion-panel-content {\n  background-color: rgb(53, 3, 3);\n} */\n\n.svg-workarea-flybar-h {\n    max-height: 23px;\n    text-align: center;\n    vertical-align: middle;\n    padding-left: 0px;\n    padding-right: 0px;\n    border-top: 1px solid var(--toolboxBorder);\n    box-shadow: 0px 1px 3px 0px #000;\n }\n\n .svg-workarea-flybar-h span {\n     padding-top: 5px !important;\n     padding-left: 3px;\n     font-size: 11px;\n }\n\n /* .svg-workarea-flybar-h:hover {\n } */\n\n .svg-workarea-flybar-h:enabled .svg-workarea-flybar-h::selection{\n     color: rgba(255,255,255,1);\n }\n\n.svg-workarea-fly-p {\n    box-shadow: none !important;\n    background-color: var(--toolboxBackground);\n    color: var(--toolboxColor);\n    width: 200px;\n    padding-left: 0px;\n    padding-right: 0px;\n}\n\n.svg-property-split3:after {\n    display: table;\n    clear: both;\n}\n\n.svg-property-split3 div {\n    /* float: left; */\n    /* width: 49%; */\n    display: inline-block;\n}\n\n.svg-property-split2:after {\n    display: table;\n    clear: both;\n}\n\n.svg-property-split2 div {\n    /* float: left; */\n    /* width: 49%; */\n    display: inline-block;\n}\n\n.svg-property {\n    color: var(--toolboxFlyColor);\n}\n\n.svg-property span {\n    /* float: left; */\n    display: block;\n    font-size: 10px;\n    margin: 0px 5px 0px 10px;\n}\n\n.svg-property input {\n    /* float: right; */\n    /* position: relative; */\n    /* left: 0px; */\n    /* right: 0px; */\n    display: block;\n    margin: 0px 10px 12px 10px;\n    border: unset;\n    background-color: inherit;\n    color: inherit;\n    border-bottom: 1px solid var(--toolboxFlyColor);\n}\n\n.svg-workarea-container {\n    display: block;\n    height: 100%;\n}\n\n.svg-preview {\n    background-color: #3058af36;\n    height: 0px;\n    width: 0px;\n    z-index: 1;\n    position: absolute;\n}\n\n#rulers > div {\n    background-color: var(--svgEditRulersBackground) !important;\n    color: var(--svgEditRulersColor) !important;\n}\n\n#svgcanvas {\n    background-color: var(--svgEditWorkareaBackground) !important;\n}\n\n.contextMenu {\n    background-color: var(--svgEditWorkareaContextMenu) !important;\n}\n\n.contextMenu A {\n    color: var(--svgEditWorkareaContextColor) !important;\n}\n\n.contextMenu LI:not(.disabled) A:hover {\n    color: var(--toolboxItemActiveColor) !important;\n}\n\n.contextMenu LI.separator {\n    margin-top: 0px !important;\n    border-color: var(--svgEditWorkareaContextBorder) !important;\n}\n\n.svg-tools-fly {\n    z-index: 9999;\n    position: absolute;\n    right: 15px;\n    top: 55px;\n    /* overflow-y: auto; */\n    max-height: calc(100% - 75px);\n    background-color: var(--toolboxBackground);\n    box-shadow: 0px 1px 4px 0px #000;\n}\n\n.svg-tool-button {\n    vertical-align: middle;\n    display: inline-table;\n    /* display: inline-block; */\n    cursor: pointer;\n    height: 30px;\n    width: 30px;\n    border-radius: 50%;\n    margin: 2px 2px 2px 2px;\n    background-color: var(--toolboxButton);\n    /* padding-top: 5px; */\n}\n\n.svg-tool-button span {\n    display: block;\n    margin: auto;\n}\n\n.svg-tool-button:hover {\n    background: rgba(0, 0, 0, 0.1);\n}\n\n.svg-tool-active, .svg-tool-active:active, .svg-tool-active:hover {\n    background-color: rgba(48,89,175,1);\n}\n\n.leave-header-area {\n    margin-top: 36px;\n}\n\n.svg-sidenav {\n    min-width: 160px;\n    max-width: 300px;\n    width: 300px;\n    background: var(--sidenavBackground);\n}\n\n/* tool bar top */\n.tools_panel {\n    background-color: var(--headerBackground);\n    color: var(--headerColor);\n}\n.main-btn {\n    height: 34px;\n    width: 34px;\n    min-width: unset !important;\n    padding: unset !important;\n    line-height: 34px;\n    margin-left: 5px;\n    margin-right: 5px;\n}\n\n.main-btn mat-icon {\n    font-size: 24px;\n    height: unset;\n    width: unset;\n}\n\n.main-btn .to-top {\n    display: inline-block;    ;\n    height: 34px;\n    width: 34px;    \n}\n\n.main-btn .to-bottom  {\n    display: inline-block;\n    height: 34px;\n    width: 34px;\n}\n\n.main-btn .to-path {\n    display: inline-block;\n    height: 34px;\n    width: 34px;\n}\n\n.main-btn .group {\n    background: url(\"/assets/images/group.svg\") no-repeat center center;\n    background-size: contain;\n    display: inline-block;\n    height: 34px;\n    width: 34px;\n}\n\n.main-btn .ungroup {\n    background: url(\"/assets/images/ungroup.svg\") no-repeat center center;\n    background-size: contain;\n    display: inline-block;\n    height: 34px;\n    width: 34px;\n}\n\n.main-btn-sep {\n    width: 1px;\n    background: #888;\n    border-left: 1px outset #888;\n    margin: 5px 3px;\n    padding: 0;\n    height: 24px;\n}\n\n.svg-element-selected {\n    display: inline-flex;\n}\n\n/* --------------- */\n/* left panel */\n/* --------------- */\n.view-panel {\n    overflow: auto;\n    cursor: s-resize;\n}\n.leftbar-edit-btn {\n    margin-top: 2px;\n    font-size: 18px;\n    height: 18px;\n    width: 18px;\n    padding-right: 15px;\n}\n\n.leftbar-panel {\n    margin-top: 4px;\n    padding: 0px 0px 0px 0px;\n    font-size: 11px;\n    background-color: var(--toolboxPanelBackground);\n    color: var(--toolboxColor);\n    overflow: auto;\n}\n\n.leftbar-panel.h200 {\n    max-height: 200px;\n}\n\n.leftbar-item {\n    padding: 3px 0px 1px 0px;\n    display: flow-root;\n}\n\n.leftbar-item-active {\n    background-color: var(--toolboxItemActiveBackground);\n    color: var(--toolboxItemActiveColor);\n}\n\n.leftbar-item span {\n    float: left;\n}\n\n.leftbar-item .leftbar-item-type {\n    float: left;\n    padding-left: 4px;\n    font-size: 16px;\n    line-height: 20px;\n    opacity:0.5;\n}\n\n.leftbar-item mat-icon {\n    float: right;\n    font-size: 18px;\n}\n\n::ng-deep .svg-workarea-leftbar-p .mat-expansion-panel-body {\n    margin: 0px 0px 0px 0px !important;\n    padding: 0px 0px 0px 0px !important;\n    /* padding-left: 10px !important; */\n    flex-wrap: wrap !important;\n}\n\n::ng-deep .svg-workarea-fly-p .mat-expansion-panel-body {\n    margin: 0px 0px 0px 0px !important;\n    padding: 0px 0px 0px 0px !important;\n    /* padding-left: 10px !important; */\n    flex-wrap: wrap !important;\n}\n\n::ng-deep .mat-menu-item {\n    font-size: 11px;\n    height: 30px !important;\n    line-height: unset !important;\n}\n\n.rightbar-panel {\n    margin-top: 4px;\n    background-color: var(--toolboxPanelBackground);\n    color: var(--toolboxColor);\n}\n\n.rightbar-input {\n    width: 70px;\n}\n\n.mat-expansion-panel-header-title span {\n    padding-top: 3px;\n}\n.mat-expansion-panel-spacing {\n    margin: 0px 0px 0px 0px !important;\n}\n\n.bottom-bar {\n    position: absolute;\n    left: 0px;\n    right: 0;\n    bottom: 0;\n    height: 30px;\n    overflow: visible;\n}\n\n.zoom-menu {\n    float: left;\n    padding-left: 5px;\n    width: 90px;\n}\n\n.zoom-value {\n    border: unset;\n    display: inline-block;\n}\n\n.zoom-label {\n    display: inline-block;\n    height: 25px;\n}\n.zoom-value span {\n    display: inline-block;\n}\n\n.zoom-value .selection,\nbutton {\n    display: inline-block;\n}\n.zoom-value button {\n    /* width: unset; */\n    z-index: 9999;\n    background-color: var(--footZoomBackground);\n    color: var(--footZoomColor);\n    border: unset;\n}\n\n.zoom-value ul,\nli {\n    /* width: unset; */\n    background-color: var(--footZoomBackground);\n    color: var(--footZoomColor);\n    border: unset;\n}\n\n.zoom-value ul {\n    left: 0px;\n}\n\n.zoom-value li:hover {\n    background-color: var(--footZoomBackgroundHover);\n}\n\n.colors {\n    position: absolute;\n    left: 25px;\n    top: 0px;\n}\n\n.colors-palette {\n    position: absolute;\n    left: 165px;\n    top: 0px;\n    right: 0px;\n    bottom: 0px;\n}\n\n.color-fill {\n    position: relative;\n    top: 4px;\n    left: 12px;\n    cursor: pointer;\n    width: 13px;\n    height: 13px;\n    border: 1px solid rgba(71, 71, 71, 1);\n}\n\n.color-stroke {\n    position: absolute;\n    top: 4px;\n    left: 30px;\n    cursor: pointer;\n    width: 13px;\n    height: 13px;\n    border: 1px solid rgba(71, 71, 71, 1);\n}\n\n.style-stroke {\n    display: block !important;\n    margin: 0px 10px 12px 10px;\n    background-color: inherit;\n    color: inherit;\n    background-color: var(--toolboxPanelBackground);\n    color: var(--toolboxColor);\n}\n\n.style-stroke option {\n    background-color: var(--toolboxPanelBackground);\n    color: var(--toolboxColor);\n}\n\n.font-family {\n    display: block;\n    margin: 0px 10px 12px 10px;\n    background-color: inherit;\n    color: inherit;\n    width: 174px;\n}\n\n.font-family option {\n    background-color: var(--toolboxPanelBackground);\n    color: var(--toolboxColor);\n}\n\n.text-align {\n    display: block;\n    margin: 0px 10px 12px 10px;\n    background-color: inherit;\n    color: inherit;\n    width: 75px;\n}\n\n.text-align option {\n    background-color: var(--toolboxPanelBackground);\n    color: var(--toolboxColor);\n}\n\n.view-item-text {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: calc(100% - 54px);\n}\n\nselect#start_marker option[value=\"A\"] {\n    background: url(\"/assets/images/select-pointer.svg\");\n}\nselect#start_marker option[value=\"B\"] {\n    background: url(\"/assets/images/select-pointer.svg\");\n}\nselect#start_marker option[value=\"C\"] {\n    background: url(\"/assets/images/select-pointer.svg\");\n}\nselect#start_marker option[value=\"D\"] {\n    background: url(\"/assets/images/select-pointer.svg\");\n}\n\n.icon-select {\n    background: url(\"/assets/images/select-pointer.svg\") no-repeat center center;\n    background-size: contain;\n    height: 30px;\n    width: 30px;\n}\n\n.icon-pencil {\n    background: url(\"/assets/images/pencil.svg\") no-repeat center center;\n    background-size: contain;\n    height: 30px;\n    width: 30px;\n}\n\n.icon-line {\n    background: url(\"/assets/images/line.svg\") no-repeat center center;\n    background-size: contain;\n    height: 30px;\n    width: 30px;\n}\n\n.icon-rect {\n    background: url(\"/assets/images/rect.svg\") no-repeat center center;\n    background-size: contain;\n    height: 30px;\n    width: 30px;\n}\n\n.icon-circle {\n    background: url(\"/assets/images/circle.svg\") no-repeat center center;\n    background-size: contain;\n    height: 30px;\n    width: 30px;\n}\n\n.icon-ellipse {\n    background: url(\"/assets/images/ellipse.svg\") no-repeat center center;\n    background-size: contain;\n    height: 30px;\n    width: 30px;\n}\n\n.icon-path {\n    background: url(\"/assets/images/path.svg\") no-repeat center center;\n    background-size: contain;\n    height: 30px;\n    width: 30px;\n}\n\n.icon-text {\n    background: url(\"/assets/images/text.svg\") no-repeat center center;\n    background-size: contain;\n    height: 30px;\n    width: 30px;\n}\n\n.icon-image {\n    background: url(\"/assets/images/image.svg\") no-repeat center center;\n    background-size: contain;\n    height: 30px;\n    width: 30px;\n}\n\n.icon-align-left {\n    background: url(\"/assets/images/align-left.svg\") no-repeat center center;\n    background-size: contain;\n    height: 30px;\n    width: 30px;\n}\n\n.icon-align-center {\n    background: url(\"/assets/images/align-center.svg\") no-repeat center center;\n    background-size: contain;\n    height: 30px;\n    width: 30px;\n}\n\n.icon-align-right {\n    background: url(\"/assets/images/align-right.svg\") no-repeat center center;\n    background-size: contain;\n    height: 30px;\n    width: 30px;\n}\n\n.icon-align-top {\n    background: url(\"/assets/images/align-top.svg\") no-repeat center center;\n    background-size: contain;\n    height: 30px;\n    width: 30px;\n}\n\n.icon-align-middle {\n    background: url(\"/assets/images/align-middle.svg\") no-repeat center center;\n    background-size: contain;\n    height: 30px;\n    width: 30px;\n}\n\n.icon-align-bottom {\n    background: url(\"/assets/images/align-bottom.svg\") no-repeat center center;\n    background-size: contain;\n    height: 30px;\n    width: 30px;\n}\n\n.icon-flip-orizontal {\n    background: url(\"/assets/images/flip-orizontal.svg\") no-repeat center center;\n    background-size: contain;\n    height: 30px;\n    width: 30px;\n}\n\n.icon-flip-vertical {\n    background: url(\"/assets/images/flip-vertical.svg\") no-repeat center center;\n    background-size: contain;\n    height: 30px;\n    width: 30px;\n}\n\n.icon-linejoin-miter {\n    background: url(\"/assets/images/linejoin-miter.svg\") no-repeat center center;\n    background-size: contain;\n    height: 30px;\n    width: 30px;\n}\n\n.icon-linejoin-round {\n    background: url(\"/assets/images/linejoin-round.svg\") no-repeat center center;\n    background-size: contain;\n    height: 30px;\n    width: 30px;\n}\n\n.icon-linejoin-bevel {\n    background: url(\"/assets/images/linejoin-bevel.svg\") no-repeat center center;\n    background-size: contain;\n    height: 30px;\n    width: 30px;\n}\n\n.icon-linecap-butt {\n    background: url(\"/assets/images/linecap-butt.svg\") no-repeat center center;\n    background-size: contain;\n    height: 30px;\n    width: 30px;\n}\n\n.icon-linecap-square {\n    background: url(\"/assets/images/linecap-square.svg\") no-repeat center center;\n    background-size: contain;\n    height: 30px;\n    width: 30px;\n}\n\n.icon-linecap-round {\n    background: url(\"/assets/images/linecap-round.svg\") no-repeat center center;\n    background-size: contain;\n    height: 30px;\n    width: 30px;\n}\n\n.icon-tool {\n    background-size: auto;\n    height: 30px;\n    width: 30px;\n    color: rgba(255, 255, 255, 1);\n    background-position: center; /* Center the image */\n    background-repeat: no-repeat; /* Do not repeat the image */\n}\n\n.material-icon-tool {\n    text-align: center;\n    line-height: 30px;\n    font-size: 22px;\n}\n\n.icon-switch {\n    background: url(\"/assets/images/switch.svg\") no-repeat center center;\n}\n.icon-value {\n    background: url(\"/assets/images/value.svg\") no-repeat center center;\n}\n.icon-editvalue {\n    background: url(\"/assets/images/editvalue.svg\") no-repeat center center;\n}\n.icon-selectvalue {\n    background: url(\"/assets/images/selectvalue.svg\") no-repeat center center;\n}\n.icon-progress-v {\n    background: url(\"/assets/images/progress-v.svg\") no-repeat center center;\n}\n.icon-semaphore {\n    background: url(\"/assets/images/semaphore.svg\") no-repeat center center;\n}\n.icon-button {\n    background: url(\"/assets/images/button.svg\") no-repeat center center;\n}\n.icon-chart {\n    background: url(\"/assets/images/chart.svg\") no-repeat center center;\n}\n.icon-bag {\n    background: url(\"/assets/images/bag.svg\") no-repeat center center;\n}\n.icon-pipe {\n    background: url(\"/assets/images/pipe.svg\") no-repeat center center;\n}\n.icon-slider {\n    background: url(\"/assets/images/slider.svg\") no-repeat center center;\n}\n.icon-graphbar {\n    background: url(\"/assets/images/graphbar.svg\") no-repeat center center;\n}\n.icon-table {\n    background: url(\"/assets/images/table.svg\") no-repeat center center;\n}\n.icon-iframe {\n    background: url(\"/assets/images/iframe.svg\") no-repeat center center;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
